<template>
  <v-app id="app">
    <router-view />
    <notifications group="foo" position="bottom right" />
  </v-app>
</template>

<script>
const default_layout = 'default';
import { Trans } from '@/plugins/translation.js';
import { mapGetters } from 'vuex';
import {
  LANG_CODE_JAPANESE,
  LANG_JAPANESE_TITLE,
  LANG_VIETNAMESE_TITLE,
  LANG_CODE_VIETNAMESE
} from '@/common/constants';

export default {
  name: 'App',
  components: {},
  methods: {
    checkCurrentLanguage() {
      const { event_code, contract_id } = this.$store.state;

      if (event_code && contract_id) {
        const keyStore = contract_id + event_code;

        const objFromLS =
          localStorage.getItem(keyStore) !== null
            ? JSON.parse(localStorage.getItem(keyStore))
            : null;

        const lang = objFromLS ? objFromLS.sekisho_lang : null;

        if (lang !== null) {
          return lang;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    getLangCodeFromEventDefault(langDefault) {
      const langActive = this.dataLanguageFromServer.filter(
        (lang) => lang.id === langDefault
      );

      return langActive.length > 0 ? langActive[0].lang_code : 'jp_en';
    },

    setLang(langDefault) {
      const isNullLanguage = this.checkCurrentLanguage();

      if (isNullLanguage === true) {
        const lang = this.getLangCodeFromEventDefault(langDefault);

        let langTitle = '';

        if (lang === LANG_CODE_JAPANESE) {
          langTitle = LANG_JAPANESE_TITLE;
        } else if (lang === LANG_CODE_VIETNAMESE) {
          langTitle = LANG_VIETNAMESE_TITLE;
        }

        Trans.changeLanguage(lang);
        this.$store.dispatch('changeLanguage', { lang, langTitle });
      } else {
        Trans.changeLanguage(isNullLanguage);
        this.$store.dispatch('changeLanguage', { isNullLanguage });
      }
    }
  },

  mounted() {
    if (this.$route.name !== 'list-company-preview') {
      this.setLang();
    }
  },

  watch: {
    status: function (val) {
      return val;
    },
    m_event: function (val) {
      // this.setLang(val.default_lang);
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    },
    ...mapGetters({
      m_event: 'getEventData',
      status: 'getStatusCheckEvent',
      checkEvent: 'getStatusCheckEvent',
      checkAuth: 'getStatusCheckAuth',
      langTitle: 'getLangDefaultTitle',
      getContractId: 'getContractId'
    })
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
  }
}

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .container {
    padding: 0;
    margin: 0;
  }
}
</style>
